const Product = () => {
    return (
        <>Product</>
    )
}
export default Product;